import * as LoadingStatus from '@dragonfruit/constants/loadingState';

export const types = {
  APPLY_DISCOUNT_CODE: 'APPLY_DISCOUNT_CODE',
  APPLY_DISCOUNT_CODE_SUCCESS: 'APPLY_DISCOUNT_CODE_SUCCESS',
  APPLY_DISCOUNT_CODE_FAILURE: 'APPLY_DISCOUNT_CODE_FAILURE',
  CANCEL_DISCOUNT_CODE: 'CANCEL_DISCOUNT_CODE',
  RESET_DISCOUNT_AMOUNT: 'RESET_DISCOUNT_AMOUNT',
};

export const actions = {
  applyDiscountCode: (discountCode, paymentMethodId, planId, planName) => ({
    type: types.APPLY_DISCOUNT_CODE,
    payload: {
      discountCode,
      paymentMethodId,
      planId,
      planName,
    },
  }),
  applyDiscountCodeSuccess: discountAmount => ({
    type: types.APPLY_DISCOUNT_CODE_SUCCESS,
    payload: {
      discountAmount,
    },
  }),
  applyDiscountCodeFailure: () => ({
    type: types.APPLY_DISCOUNT_CODE_FAILURE,
  }),
  cancelDiscountCode: () => ({
    type: types.CANCEL_DISCOUNT_CODE,
  }),
  resetDiscountAmount: () => ({
    type: types.RESET_DISCOUNT_AMOUNT,
  }),
};

const initialState = {
  loadingStatus: LoadingStatus.EMPTY,
  discountAmount: 0,
  discountCode: '',
};

/*eslint-disable complexity */
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.APPLY_DISCOUNT_CODE:
      return {
        ...state,
        loadingStatus: LoadingStatus.LOADING,
        discountCode: payload.discountCode,
      };
    case types.APPLY_DISCOUNT_CODE_SUCCESS:
      return {
        ...state,
        loadingStatus: LoadingStatus.READY,
        discountAmount: payload.discountAmount,
      };
    case types.APPLY_DISCOUNT_CODE_FAILURE:
      return {
        ...state,
        loadingStatus: LoadingStatus.ERROR,
      };
    case types.CANCEL_DISCOUNT_CODE:
      return {
        ...initialState,
      };
    case types.RESET_DISCOUNT_AMOUNT:
      return {
        ...state,
        discountAmount: initialState.discountAmount,
      };
    default:
      return state;
  }
};

export default reducer;

export const getDiscountAmount = state => state.discountCode.discountAmount;
export const getDiscountCode = state => state.discountCode.discountCode;
export const getLoadingStatus = state => state.discountCode.loadingStatus;
export const getValidDiscountCode = state => {
  const { loadingStatus, discountCode } = state.discountCode;
  if (loadingStatus !== LoadingStatus.READY) return '';

  return discountCode;
};



// WEBPACK FOOTER //
// ./app/redux/discountCode.js